import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Landing from "@/components/Landing";
import CateringCalculator from "@/components/CateringCalculator";
import PartyHallCalculator from "@/components/PartyHallCalculator";

function BackBar() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  return (
    <Link to="/" className="pad-backbar" data-testid="pad-back-link">
      <ArrowLeft size={16} strokeWidth={1.8} />
      <span>All calculators</span>
    </Link>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <BackBar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/convention" element={<CateringCalculator />} />
          <Route path="/party" element={<PartyHallCalculator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
